import React from 'react'
import WovvLogo from "./WOVV-IA-Logo.png"
import "./style.css"

function MscerFooter() {
  return (
    <div className='container-fluid'>
            <span className='footer-text'>Powered by</span>
            <a href='https://wovvtech.com/' target={'_blank'}><img src='images/wovvtech_logo.jpg' alt="logo" width='36px'/></a>
    </div>
  )
}

export default MscerFooter